import {loginBoxHtml} from '../loginBox.js';

export default function() {
  const widgetName = 'cardWidgetHomepageText';
  const widgetOpts = cardWidgetHomepageTextOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      const title = data.items[0].Title;
      $('.section-tier-two').prepend(`<h2>${title}</h2>`);
      $(`#${widgetName} .card-widget-title`).remove();

      $(`#${widgetName}`).append(loginBoxHtml);
      $(`
        <div style="font-size: 0.6875em;">
          <p style="margin-top: 0;">Got LMS Questions and/or Concerns?<br> <a href="https://forms.monday.com/forms/8610b1ca185958b87c8bfbac298cc700?r=use1" style="font-weight: 900" target="_blank">CLICK HERE</a> to submit a ticket to the Learning and Development Team.</p>
        </div>
      `).insertAfter('.loginBox');

      // $('#venue-select').on('change', function() {
      //   const loginBtn = $('#login-btn');
      //   // let selected = $(this).find(':selected');

      //   // let url = "";
      //   // if (selected.attr('data-sso') === "true") {
      //   //   url = "https://myapps.microsoft.com/signin/Litmos/d71dab52-83e1-413d-8bd2-5e1757a3870a?tenantId=1c95a1cf-2a77-4a93-b021-096144568ecd";
      //   // } else {
      //   //   url = "https://asmg.litmos.com/";
      //   // }

      //   loginBtn.removeClass('button--disabled');
      //   loginBtn.attr('target', '_blank');
      //   loginBtn.attr('href', 'https://asmg.litmos.com/account/login/');
      // });

      // $('#login-btn').on('click keypress', function(event) {
      //   if (event.key === 'Enter' || event.type === 'click') {
      //     if ($(this).hasClass('button--disabled')) {
      //       event.preventDefault();
      //       alert('Please select a venue from the list.');
      //     }
      //   }        
      // })
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}